import { render, staticRenderFns } from "./pro-tree-node.vue?vue&type=template&id=2a7a0d9b&scoped=true";
import script from "./pro-tree-node.vue?vue&type=script&lang=js";
export * from "./pro-tree-node.vue?vue&type=script&lang=js";
import style0 from "./pro-tree-node.vue?vue&type=style&index=0&id=2a7a0d9b&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "2a7a0d9b", null);
export default component.exports;